var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.001,
    height: 16,
    viewBox: "0 0 21.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M14.281,16a2.521,2.521,0,0,0,.037-.432,7.34,7.34,0,0,0-1.1-4.1,7.488,7.488,0,0,1,2.534-.39A6.069,6.069,0,0,1,19.462,12.1,4.151,4.151,0,0,1,21,15.621a.356.356,0,0,1-.326.379ZM.385,16A.412.412,0,0,1,0,15.567a4.676,4.676,0,0,1,1.817-4.027A7.345,7.345,0,0,1,6.2,10.379a7.345,7.345,0,0,1,4.387,1.162,4.628,4.628,0,0,1,1.816,3.888c0,.013,0,.027,0,.04s0,.018,0,.028,0,.046,0,.069v0h0s0,.01,0,.015V15.6a.441.441,0,0,1-.181.333l0,0-.006,0-.011.007h0a.35.35,0,0,1-.18.051ZM13.827,8.57a5.932,5.932,0,0,1-.7-2.786C13.126,3.924,14.107,2,15.75,2s2.625,1.924,2.625,3.784a5.943,5.943,0,0,1-.7,2.786A2.3,2.3,0,0,1,15.75,9.946,2.3,2.3,0,0,1,13.827,8.57ZM3.93,7.509A6.615,6.615,0,0,1,3.1,4.325C3.1,2.2,4.262,0,6.2,0s3.1,2.2,3.1,4.325a6.615,6.615,0,0,1-.828,3.184A2.721,2.721,0,0,1,6.2,9.081,2.721,2.721,0,0,1,3.93,7.509Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.3e6a0293b62e538efd75d3523b6f1e7b.svg";
export { ForwardRef as ReactComponent };